export function isRustEngineEnabled(params: URLSearchParams): boolean {
  return params.get('engine') === 'rust';
}

// Escape hatch for surfaces where rust is the default (student gallery) — ?engine=konva falls back to legacy.
export function isKonvaEngineForced(params: URLSearchParams): boolean {
  return params.get('engine') === 'konva';
}

export function isRustTextShaperEnabled(params: URLSearchParams): boolean {
  return params.get('textshaper') !== 'opentype';
}

export function isRustCameraEnabled(params: URLSearchParams): boolean {
  return params.get('camera') === '1';
}
